export default function fCopyObject(obj: any) {
    return JSON.parse(JSON.stringify(obj));
}
